<template>
    <ul class="shopping-pictograms">
        <li
            v-for="pictogram in pictograms"
            :key="`pictogram-${pictogram.code}`"
            :class="[ 'shopping-pictograms__item', `shopping-pictograms__item--${pictogram.code}` ]"
        >
            <h3 class="shopping-pictograms__title">
                <BaseLink
                    :href="pictogram.url"
                    :title="`Zakupy w Castorama - ${pictogram.label}`"
                    class="shopping-pictograms__link"
                >
                    <span class="shopping-pictograms__text">
                        {{ pictogram.label }}
                    </span>
                </BaseLink>
            </h3>
        </li>
    </ul>
</template>

<script>
import BaseLink from '~/components/common/Link/BaseLink';

export default {
    name: 'ShoppingPictograms',
    components: { BaseLink },
    data() {
        return {
            pictograms: [
                {
                    code: 'delivery',
                    label: 'Transport',
                    url: `${process.env.baseUrl}/informacje/zamow-z-dostawa`,
                },
                {
                    code: 'delivery-phone',
                    label: 'Zakupy na telefon',
                    url: `${process.env.baseUrl}/informacje/zakupy-w-castorama/zakupy-przez-telefon`,
                },
                {
                    code: 'return',
                    label: 'Zwroty towarów',
                    url: `${process.env.baseUrl}/informacje/zakupy-w-castorama/zwrot-towaru`,
                },
                {
                    code: 'complaint',
                    label: 'Reklamacje',
                    url: `${process.env.baseUrl}/informacje/zakupy-w-castorama/reklamacje`,
                },
                {
                    code: 'installments',
                    label: 'Zakupy na raty',
                    url: `${process.env.baseUrl}/karta-kredytowa-info`,
                },
                {
                    code: 'additional-services',
                    label: 'Usługi dodatkowe',
                    url: `${process.env.baseUrl}/informacje/zakupy-w-castorama/uslugi_dodatkowe`,
                },
                {
                    code: 'quality-guarantee',
                    label: 'Gwarancja jakości',
                    url: `${process.env.baseUrl}/informacje/zamow-z-dostawa`,
                },
                {
                    code: 'lowest-price',
                    label: 'Gwarancja najniższych cen',
                    url: 'https://regulaminy.e24files.com/Regulamin_nanizszej_ceny_2015.pdf',
                },
                {
                    code: 'without-problems',
                    label: 'Zwroty bez problemu',
                    url: `${process.env.baseUrl}/informacje/zakupy-w-castorama/zwrot-towaru`,
                },
            ],
        };
    },
};
</script>

<style lang="scss">
    @import '~/assets/css/sprites/homepage-pictograms.scss';

    .shopping-pictograms {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-flow: row wrap;

        &__item  {
            text-align: center;
            font: $font-weight-bold 16px/18px $goodHomeFontFamily;
            color: $color-castoWhite;
            flex: 0 1 16.66%;
            margin: 40px 0 0 0;
        }

        &__link {
            display: inline-block;
            width: 100%;
            min-height: 32px;
            color: $color-castoWhite;

            &:hover {
                text-decoration: none;
                color: $color-castoYellow;
            }

            &::before {
                display: inline-block;
                width: 100%;
                content: '';
                min-height: 50px;
                background-size: 100% auto;
                background-repeat: no-repeat;
                background-position: top center;
            }
        }

        &__text {
            display: inline-block;
            width: 100%;
            min-height: 32px;
            margin: 18px 0 0 0;
            padding: 0 5px;
        }

        &__item--delivery &__link::before {
            @include spriteHomepagePictograms('delivery-white', false, true);
            height: 58px;
            margin: 7px 0 6px 0;
        }

        &__item--delivery &__link:hover::before {
            @include spriteHomepagePictograms('delivery-yellow', false, true);
        }

        &__item--delivery-phone &__link::before {
            height: 50px;
            margin: 10px 0 11px 0;
            @include spriteHomepagePictograms('delivery-phone-white', false, true);
        }

        &__item--delivery-phone &__link:hover::before {
            @include spriteHomepagePictograms('delivery-phone-yellow', false, true);
        }

        &__item--return &__link::before{
            height: 65px;
            margin: 3px 0;
            @include spriteHomepagePictograms('return-white', false, true);
        }

        &__item--return &__link:hover::before{
            @include spriteHomepagePictograms('return-yellow', false, true);
        }

        &__item--complaint &__link::before {
            height: 49px;
            margin: 11px 0;
            @include spriteHomepagePictograms('shield-white', false, true);
        }

        &__item--complaint &__link:hover::before {
            @include spriteHomepagePictograms('shield-yellow', false, true);
        }

        &__item--installments &__link::before {
            height: 55px;
            margin: 8px 0;
            @include spriteHomepagePictograms('calendar-logo-white', false, true);
        }

        &__item--installments &__link:hover::before {
            @include spriteHomepagePictograms('calendar-logo-yellow', false, true);
        }

        &__item--additional-services &__link::before {
            height: 59px;
            margin: 6px 0;
            @include spriteHomepagePictograms('additional-services-white', false, true);
        }

        &__item--additional-services &__link:hover::before{
            @include spriteHomepagePictograms('additional-services-yellow', false, true);
        }

        &__item--quality-guarantee &__link::before {
            height: 71px;
            @include spriteHomepagePictograms('quality-guarantee-white', false, false);
            background-size: 47px 71px;
        }

        &__item--quality-guarantee &__link:hover::before {
            @include spriteHomepagePictograms('quality-guarantee-yellow', false, false);
            background-size: 47px 71px;
        }

        &__item--lowest-price &__link::before {
            height: 71px;
            background-image: url('~static/images/svg/lowest-price-guarantee-white.svg');
            background-size: 49px 71px;
        }

        &__item--lowest-price &__link:hover::before {
            background-image: url('~static/images/svg/lowest-price-guarantee-yellow.svg');
            background-size: 49px 71px;
        }

        &__item--without-problems &__link::before {
            margin: 10px 0;
            height: 50px;
            @include spriteHomepagePictograms('delivery-car-white', false, true);
            background-size: 84px 51px;
        }

        &__item--without-problems &__link:hover::before{
            @include spriteHomepagePictograms('delivery-car-yellow', false, true);
            background-size: 84px 51px;
        }

        &__image-wrapper {
            display: inline-block;
            width: 100%;

            img {
                width: 100%;
            }
        }

        &__title, &__image-wrapper {
            display: inline-block;
        }

        &__title {
            padding: 0;
            width: 100%;
        }
    }

    @media screen and (min-width: $breakpoint-small-desktop) {
        .shopping-pictograms__item--lowest-price {
            flex: 0 1 33%;
        }
    }

    @media screen and (max-width: $breakpoint-small-desktop) {
        .shopping-pictograms {
            padding-top: 10px;
            margin-bottom: -10px;

            &__item  {
                flex: 0 1 25%;
                margin: 25px 0 0 0;
            }

            &__item--installments &__link::before {
                margin: 8px 0 7px 0;
            }

            &__item--additional-services &__link::before {
                margin: 8px 0;
            }
        }
    }
</style>
